module.exports = __webpack_public_path__ + "static/media/autoDoor1.ec631d3b.png";